module.exports = __webpack_public_path__ + "static/Action-Shots-2-fd4fc9a945f469b28fd013509b844d31.jpg";